import { render, staticRenderFns } from "./InformationObligation.vue?vue&type=template&id=5450e245&"
import script from "./InformationObligation.vue?vue&type=script&lang=js&"
export * from "./InformationObligation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports